import React from "react";
import { GEBREK_COLORS, KLEUR_OPTIONS } from "../../../utils/constants";
import Tekst from "../../reports/Tekstenbieb";
import AddToTekstenbieb from "./AddToTesktenbieb";

export default function DetailsSection({
    gebrek,
    index,
    PRIORITEIT_OPTIONS,
    onChange,
    handleTekstBiebOmschrijving
}) {
    return (
        <>
            {/* Prioriteit & Kleur */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="flex flex-col space-y-1">
                    <label
                        htmlFor={`prioriteit-${gebrek.gebrekid}`}
                        className="text-sm font-semibold text-gray-700"
                    >
                        Prioriteit:
                    </label>
                    <select
                        id={`prioriteit-${gebrek.gebrekid}`}
                        value={gebrek?.gebreksortering?.naam || PRIORITEIT_OPTIONS[0]}
                        onChange={(e) => onChange(index, "prioriteit", e.target.value)}
                        className="p-3 border rounded-md shadow-sm focus:ring focus:ring-blue-300 bg-white"
                    >
                        {PRIORITEIT_OPTIONS.map((opt) => (
                            <option key={opt} value={opt}>
                                {opt}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="flex flex-col space-y-1">
                    <label
                        htmlFor={`kleur-${gebrek.gebrekid}`}
                        className="text-sm font-semibold text-gray-700"
                    >
                        Kleur (overschrijft code):
                    </label>
                    <select
                        id={`kleur-${gebrek.gebrekid}`}
                        value={(() => {
                            // Check gebrek.kleur first, then fallback to gebrek.gebrekcode.naam
                            const colorValue = gebrek.kleur || gebrek.gebrekcode?.naam;
                            return colorValue && KLEUR_OPTIONS.includes(colorValue) ? colorValue : "";
                        })()}
                        onChange={(e) => onChange(index, "kleur", e.target.value)}
                        className="p-3 border rounded-md shadow-sm focus:ring focus:ring-blue-300 bg-white"
                        style={{
                            color: (() => {
                                const colorValue = gebrek.kleur || gebrek.gebrekcode?.naam;
                                return colorValue && GEBREK_COLORS[colorValue] ? GEBREK_COLORS[colorValue] : "inherit";
                            })(),
                        }}
                    >
                        {KLEUR_OPTIONS.map((opt) => (
                            <option
                                key={opt}
                                value={opt}
                                style={{ color: opt ? GEBREK_COLORS[opt] : "black" }}
                            >
                                {opt || "Geen kleur"}
                            </option>
                        ))}
                    </select>
                </div>
            </div>

            {/* Omschrijving Input with Tekstenbieb */}
            <div className="flex flex-col space-y-1">
                <div className="flex items-center justify-between">
                    <label
                        htmlFor={`omschrijving-${gebrek.gebrekid}`}
                        className="text-sm font-semibold text-gray-700"
                    >
                        Omschrijving:
                    </label>
                    <div className="flex items-center">
                        <Tekst toParent={handleTekstBiebOmschrijving} />
                        <AddToTekstenbieb
                            currentText={gebrek.omschrijving || ""}
                            currentToelichting={gebrek.toelichting || ""}
                            fieldType="omschrijving"
                            onTextCreated={(text) => {
                                if (text.omschrijving) {
                                    onChange(index, "omschrijving", text.omschrijving);
                                }
                                const huidigeToelichting = (gebrek.toelichting ?? "").trim();
                                if (text.toelichting && huidigeToelichting === "") {
                                    onChange(index, "toelichting", text.toelichting);
                                }
                            }}
                        />
                    </div>
                </div>
                <input
                    id={`omschrijving-${gebrek.gebrekid}`}
                    type="text"
                    value={gebrek.omschrijving || ""}
                    onChange={(e) => onChange(index, "omschrijving", e.target.value)}
                    className="p-3 border rounded-md shadow-sm focus:ring focus:ring-blue-300 flex-grow"
                    placeholder="Omschrijving van het gebrek"
                />
            </div>

            {/* Toelichting Input with Tekstenbieb */}
            <div className="flex flex-col space-y-1">
                <div className="flex items-center justify-between">
                    <label
                        htmlFor={`toelichting-${gebrek.gebrekid}`}
                        className="text-sm font-semibold text-gray-700"
                    >
                        Toelichting:
                    </label>
                </div>
                <input
                    id={`toelichting-${gebrek.gebrekid}`}
                    type="text"
                    value={gebrek.toelichting || ""}
                    placeholder="Vul hier een toelichting in (optioneel)"
                    onChange={(e) => onChange(index, "toelichting", e.target.value)}
                    className="p-3 border rounded-md shadow-sm focus:ring focus:ring-blue-300 flex-grow"
                />
            </div>

            <div className="flex flex-col space-y-1">
                <div className="flex items-center justify-between">
                    <label
                        htmlFor={`indeling-${gebrek.gebrekid}`}
                        className="text-sm font-semibold text-gray-700"
                    >
                        Indeling:
                    </label>
                </div>
                <input
                    id={`indeling-${gebrek.gebrekid}`}
                    type="text"
                    value={gebrek.indeling || ""}
                    onChange={(e) => onChange(index, "indeling", e.target.value)}
                    className="p-3 border rounded-md shadow-sm focus:ring focus:ring-blue-300 flex-grow"
                    placeholder="Indeling van het gebrek"
                />
            </div>
        </>
    );
}